// 模拟后端动态生成路由
import { defineFakeRoute } from "vite-plugin-fake-server/client"

/**
 * roles：页面级别权限，这里模拟二种 "admin"、"common"
 * admin：管理员角色
 * common：普通角色
 */
const mockArr = [
  // 管理端
  {
    path: "/paper",
    name: "AdminPaper",
    meta: {
      title: "试卷管理",
      icon: "ep:lollipop",
      rank: 1,
      roles: ["admin"]
    },
    children: [
      {
        path: "/paper/browse",
        name: "AdminPaperBrowse",
        meta: {
          title: "浏览试题"
        },
        component: "user-admin/paper/browse/index"
      },
      {
        path: "/paper/random",
        name: "AdminPaperRandom",
        meta: {
          title: "随机组卷"
        },
        component: "user-admin/paper/random/index"
      },
      {
        path: "/paper/basket",
        name: "AdminPaperBasket",
        meta: {
          title: "试题篮"
        },
        component: "user-admin/paper/basket/index"
      },
      {
        path: "/paper/center",
        name: "AdminPaperCenter",
        meta: {
          title: "试卷中心"
        },
        component: "user-admin/paper/center/index"
      }
    ]
  },
  // {
  //   path: "/bank",
  //   name: "AdminBank",
  //   meta: {
  //     title: "题库管理",
  //     icon: "ep:lollipop",
  //     rank: 2,
  //     roles: ["admin"]
  //   },
  // },
  {
    path: "/exam",
    name: "AdminExam",
    meta: {
      title: "考试测评",
      icon: "ep:lollipop",
      rank: 3,
      roles: ["admin"]
    },
    children: [
      {
        path: "/exam/list",
        name: "AdminExamList",
        meta: {
          title: "考试列表"
        },
        component: "user-admin/exam/list/index"
      },
      {
        path: "/exam/analysis",
        name: "AdminExamAnalysis",
        meta: {
          title: "考试分析"
        },
        component: "user-admin/exam/analysis/index"
      },
      {
        path: "/exam/score/:id",
        name: "AdminExamScore",
        meta: {
          title: "成绩列表",
          showLink: false,
          activePath: "/exam/list"
        },
        component: "user-admin/exam/score/index"
      },
      {
        path: "/exam/score/detail/:id",
        name: "AdminExamScoreDetail",
        meta: {
          title: "查看考卷",
          showLink: false,
          activePath: "/exam/list"
        },
        component: "user-admin/exam/score/children/score-detail/index"
      },
      {
        path: "/exam/correct/:id",
        name: "AdminExamCorrect",
        meta: {
          title: "批改试卷",
          showLink: false,
          activePath: "/exam/list"
        },
        component: "user-admin/exam/correct/index"
      }
    ]
  },
  {
    path: "/system",
    name: "AdminSystem",
    meta: {
      title: "系统管理",
      icon: "ep:lollipop",
      rank: 4,
      roles: ["admin"]
    },
    children: [
      {
        path: "/system/project-cfg",
        name: "AdminSystemProjectCfg",
        meta: {
          title: "项目配置",
          showParent: true
        },
        component: "user-admin/system/project-cfg/index"
      }
      // {
      //   path: "/system/menu",
      //   name: "AdminSystemMenu",
      //   meta: {
      //     title: "菜单管理"
      //   },
      //   component: "user-admin/system/menu/index"
      // }
    ]
  },
  {
    path: "/propose",
    name: "AdminPropose",
    meta: {
      title: "命题计划",
      icon: "ep:lollipop",
      rank: 5,
      roles: ["admin"]
    },
    children: [
      {
        path: "/propose/plan",
        name: "AdminProposePlan",
        meta: {
          title: "命题计划管理"
        },
        component: "user-admin/propose/plan/index"
      },
      {
        path: "/propose/mine",
        name: "AdminProposeMine",
        meta: {
          title: "我的命题任务"
        },
        component: "user-admin/propose/mine/index"
      },
      {
        path: "/propose/approval",
        name: "AdminProposeApproval",
        meta: {
          title: "我的审卷任务"
        },
        component: "user-admin/propose/approval/index"
      }
    ]
  },
  {
    path: "/statistic",
    name: "AdminStatistic",
    meta: {
      title: "统计信息",
      icon: "ep:lollipop",
      rank: 6,
      roles: ["admin"]
    },
    children: [
      {
        path: "/statistic/course",
        name: "AdminStatisticCourse",
        meta: {
          title: "课程开设统计"
        },
        component: "user-admin/statistic/course/index"
      },
      {
        path: "/statistic/quantity",
        name: "AdminStatisticQuantity",
        meta: {
          title: "题库题量统计"
        },
        component: "user-admin/statistic/quantity/index"
      },
      {
        path: "/statistic/structure",
        name: "AdminStatisticStructure",
        meta: {
          title: "试题结构统计"
        },
        component: "user-admin/statistic/structure/index"
      },
      {
        path: "/statistic/ranking",
        name: "AdminStatisticRanking",
        meta: {
          title: "录题榜单"
        },
        component: "user-admin/statistic/ranking/index"
      },
      {
        path: "/statistic/paper",
        name: "AdminStatisticPaper",
        meta: {
          title: "试卷统计"
        },
        component: "user-admin/statistic/paper/index"
      }
    ]
  },
  // 学员端
  {
    path: "/student-exam",
    name: "StudentExam",
    meta: {
      title: "考试/测验",
      icon: "ep:lollipop",
      rank: 2,
      roles: ["student"]
    },
    children: [
      {
        path: "/student-exam/index",
        name: "StudentExamIndex",
        meta: {
          title: "考试/测验"
        },
        component: "user-student/exam/index"
      },
      {
        path: "/student-exam/index/:id",
        name: "StudentExamRoom",
        meta: {
          title: "考试考场",
          showLink: false,
          activePath: "/student-exam/index"
        },
        component: "user-student/exam/children/exam-room/index"
      }
    ]
  },
  {
    path: "/student-practice",
    name: "StudentPractice",
    meta: {
      title: "练习/自测",
      icon: "ep:lollipop",
      rank: 3,
      roles: ["student"]
    },
    children: [
      {
        path: "/student-practice/index",
        name: "StudentPracticeIndex",
        meta: {
          title: "练习/自测"
        },
        component: "user-student/practice/index"
      },
      {
        path: "/student-practice/index/:id",
        name: "StudentPracticeRoom",
        meta: {
          title: "练习考场",
          showLink: false,
          activePath: "/student-practice/index"
        },
        component: "user-student/practice/children/practice-room/index"
      }
    ]
  },
  {
    path: "/student-score",
    name: "StudentScore",
    meta: {
      title: "成绩查询",
      icon: "ep:lollipop",
      rank: 4,
      roles: ["student"]
    },
    children: [
      {
        path: "/student-score/index",
        name: "StudentScoreIndex",
        meta: {
          title: "成绩查询"
        },
        component: "user-student/score/index"
      },
      {
        path: "/student-score/index/:id",
        name: "StudentScoreDetail",
        meta: {
          title: "查看考卷",
          showLink: false,
          activePath: "/student-score/index"
        },
        component: "user-student/score/children/score-detail/index"
      }
    ]
  },
  {
    path: "/student-review",
    name: "StudentReview",
    meta: {
      title: "错题复习",
      icon: "ep:lollipop",
      rank: 5,
      roles: ["student"]
    },
    children: [
      {
        path: "/student-review/index",
        name: "StudentReviewIndex",
        meta: {
          title: "错题复习"
        },
        component: "user-student/review"
      }
    ]
  }
]

export default defineFakeRoute([
  {
    url: "/get-async-routes",
    method: "get",
    response: () => {
      return {
        success: true,
        data: [...mockArr]
      }
    }
  }
])
